import { Dropdown } from "semantic-ui-react";

import { useSystemTagOptions } from "modules/LeadsDashboard/hooks";

type TagsFilterProps = {
  value: number[];
  onChangeHandler: (value: number[]) => void;
};

export const TagsFilter = ({ onChangeHandler, value }: TagsFilterProps) => {
  const { systemTagOptions } = useSystemTagOptions();

  return (
    <Dropdown
      value={value}
      multiple={true}
      selection={true}
      selectOnBlur={false}
      options={systemTagOptions}
      onChange={(_e, { value }) => onChangeHandler(value as number[])}
    />
  );
};
